module.exports = __webpack_public_path__ + "img/env-football.74d1f3aa.png";